import {tableURLStateSchema} from "@project/components/data-display/table";
import type {serviceNotesRouteApi} from "./-route-api";
import {z} from "zod";

export const serviceNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type ServiceNotesSearch = z.infer<typeof serviceNotesSearchSchema>;
export type ServiceNotesNavigateFn = ReturnType<typeof serviceNotesRouteApi.useNavigate>;
